(function () {
  function activateTab(group, button) {
    var targetId = button.getAttribute('aria-controls');
    var buttons = group.querySelectorAll('.chiptee-tabs__button');
    var panels = group.querySelectorAll('.chiptee-tabs__panel');

    buttons.forEach(function (item) {
      var isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach(function (panel) {
      var isActive = panel.id === targetId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.chiptee-tabs__button');
    if (!button) return;

    var group = button.closest('.chiptee-tabs');
    if (!group) return;

    activateTab(group, button);
  });
})();
